import { AnalyticsComposite } from '..'
import { EventProviderMap } from '../constants'
import { makeMetaPixelProvider } from './meta-pixel-provider-factory'
import { makePostHogProvider } from './posthog-provider-factory'
import { PROVIDER_NAMES } from '~/composables/analytics/providers/constants'

export const makeAnalyticsComposite = (config = {}) => {
  const providers = {}
  const providerInstances = []

  const posthog = makePostHogProvider.posthog()
  if (posthog) {
    providers[PROVIDER_NAMES.POSTHOG] = posthog
    providerInstances.push(posthog)
  }

  const metaPixelId = config.metaPixelId || '846032844744249'
  const metaPixel = makeMetaPixelProvider.metaPixel(metaPixelId)
  if (metaPixel) {
    providers[PROVIDER_NAMES.META_PIXEL] = metaPixel
    providerInstances.push(metaPixel)
  }

  const eventProviderMap = config.eventProviderMap || EventProviderMap

  return new AnalyticsComposite(providerInstances, eventProviderMap, providers)
}
